import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const { attributes } = props;
	const { time, timeUnit } = attributes;
	const blockProps = useBlockProps.save({
		className: 'c4l-estimated-time'
	});
	return (
		<div {...blockProps}>
			<div className="c4l-estimated-time-container">
				<RichText.Content
					tagName='div'
					className='c4l-estimated-time-time'
					value={time}
				/>
				<RichText.Content
					tagName='div'
					className='c4l-estimated-time-time-unit'
					value={timeUnit}
				/>
			</div>
		</div>
	);
}
